import { BarChartProps } from '@mui/x-charts';
import {
  SingleOrDoubleAxisConfig,
  XAxisConfig,
  YAxisConfig,
} from '../common/common-chart-types';
import {
  getMarginsForNonHorizontalCharts,
  getModifiedXAxisConfigs,
  getPlotSideMargins,
  ModifiedXAxisConfig,
  XTickLabelOptions,
} from '../common/common-chart-utils/common-chart-display-utils';
import { MuiBarChartDataConfig } from './bar-chart-types';

export const getModifiedXAxisConfigsBarChart = (
  {
    isHorizontal,
    xAxisConfigs,
  }: {
    isHorizontal: boolean;
    xAxisConfigs: SingleOrDoubleAxisConfig<XAxisConfig<any>>;
  },
  dataset: BarChartProps['dataset'],
  elementWidth: number,
  options?: XTickLabelOptions
): SingleOrDoubleAxisConfig<ModifiedXAxisConfig<any>> => {
  return getModifiedXAxisConfigs(
    { isHorizontal, xAxisConfigs },
    dataset,
    elementWidth,
    options
  );
};

// Width the bars span, used to size x tick labels before the margins are final
export const getPlotWidthBarChart = (
  yAxisConfigs: SingleOrDoubleAxisConfig<YAxisConfig<any>> | undefined,
  series: (MuiBarChartDataConfig['series'][number] & {
    id: string;
    dataKey: string;
  })[],
  dataset: BarChartProps['dataset'] = [],
  elementWidth: number,
  showLegend = false
) => {
  const { left, right } = getPlotSideMargins(
    yAxisConfigs,
    series,
    dataset,
    elementWidth,
    showLegend
  );
  return elementWidth - left - right;
};

export const getMarginsBarChart = (
  xAxisConfigs: SingleOrDoubleAxisConfig<ModifiedXAxisConfig<any>>,
  yAxisConfigs: SingleOrDoubleAxisConfig<YAxisConfig<any>> | undefined,
  series: (MuiBarChartDataConfig['series'][number] & {
    id: string;
    dataKey: string;
  })[],
  dataset: BarChartProps['dataset'] = [],
  elementWidth: number,
  showLegend: boolean = false
) => {
  return getMarginsForNonHorizontalCharts(
    xAxisConfigs,
    yAxisConfigs,
    series,
    dataset,
    elementWidth,
    showLegend
  );
};
